// Main Project — Card Color Swap
// Clicking a color bullet on a product card swaps the displayed image to that
// color's variant and rewrites the card's product links to deep-link to the
// chosen variant.
(function () {
  function swap(card, btn) {
    const front = btn.getAttribute('data-image-front');
    const back  = btn.getAttribute('data-image-back');
    const href  = btn.getAttribute('data-href');

    // Card uses two <img> in .card__media .media (front + back-on-hover).
    const imgs = card.querySelectorAll('.card__media .media img');
    if (front && imgs[0]) {
      imgs[0].removeAttribute('srcset');
      imgs[0].src = front;
    }
    if (back && imgs[1]) {
      imgs[1].removeAttribute('srcset');
      imgs[1].src = back;
    } else if (!back && imgs[1]) {
      // If chosen color has no back image, hide the second one
      imgs[1].style.display = 'none';
    }

    if (href) {
      card.querySelectorAll('a[href]').forEach(function (a) {
        try {
          // only rewrite product links inside this card
          if (a.getAttribute('href') && a.getAttribute('href').includes('/products/')) {
            a.setAttribute('href', href);
          }
        } catch (e) {}
      });
    }

    // active state
    card.querySelectorAll('.mp-card-color').forEach(function (b) {
      b.classList.remove('is-active');
    });
    btn.classList.add('is-active');
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.mp-card-color');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const card = btn.closest('.card-wrapper');
    if (!card) return;
    swap(card, btn);
  }, true);

  // Hover-preview: swap on mouseenter, no click required (no navigation).
  document.addEventListener('mouseenter', function (e) {
    const btn = e.target && e.target.classList && e.target.classList.contains('mp-card-color') ? e.target : null;
    if (!btn) return;
    const card = btn.closest('.card-wrapper');
    if (!card) return;
    swap(card, btn);
  }, true);
})();
